// Shell-wide state of the scope chooser (U7): dismissing a card, restoring from Set aside and
// giving a verdict offer it through here, and the one TeachHost in the shell shows it.
import { useSyncExternalStore } from "react";
import { offersTeach, type TeachTarget } from "./teach";

export interface TeachState {
  open: boolean;
  target: TeachTarget | null;
  /** Bumps on every offer so the chooser starts fresh. */
  seq: number;
}

let state: TeachState = { open: false, target: null, seq: 0 };
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export const teachStore = {
  offer(target: TeachTarget) {
    if (!target.threadKey || !offersTeach(target.surface, target.verdict)) return;
    state = { open: true, target, seq: state.seq + 1 };
    emit();
  },
  close() {
    if (!state.open) return;
    state = { ...state, open: false };
    emit();
  },
  get(): TeachState {
    return state;
  },
};

/** Offers the chooser for a thread (no-op without one). */
export function offerTeach(
  target: Omit<TeachTarget, "threadKey"> & { threadKey: string | null | undefined },
) {
  const { threadKey } = target;
  if (threadKey) teachStore.offer({ ...target, threadKey });
}

export function useTeachState(): TeachState {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
    () => state,
  );
}
